import { noticeActions } from "@service/store/notice/actions";
import { GroupedNoticeParams } from "@service/store/types/NoticeState";
import { Dispatch } from "vuex";
import { NoticeFabric } from "./NoticeFabric";

export enum MessageType {
    raiseHand = "RaiseHand"
}

export class NoticeProxy {
    constructor(private dispatch: Dispatch, private fabric: NoticeFabric) {
    }

    submitGroupedNotice<T>(data: T[], groupName: MessageType, groupId: string) {
        const messages = this.fabric.getMessage<T>(data, groupName, groupId);

        this.dispatch(noticeActions.submitGroupedNotice, { groupId, data: messages } as GroupedNoticeParams)
    }
}